module.exports = __webpack_public_path__ + "media/images/products/wedding/img-hero-mobile-2f60fbdbf12e2abe607a23bf8b563804.png";